var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Divider from "@material-ui/core/Divider";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { maybe } from "tsmonads";
import serverUri from "../../config";
import { WebSocketMessage } from "../../serverConnection";
var VideoList = /** @class */ (function (_super) {
    __extends(VideoList, _super);
    function VideoList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VideoList.prototype.render = function () {
        var _this = this;
        var videos = this.props.videos.map(function (video) {
            var _a, _b, _c, _d;
            var owner = maybe(_this.props.users.get((_a = video.user) !== null && _a !== void 0 ? _a : ""))
                .map(function (u) { return u.company; })
                .orElse((_c = (_b = video.area) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "");
            return (React.createElement(ExpansionPanel, { key: video.id },
                React.createElement(ExpansionPanelSummary, { expandIcon: React.createElement(ExpandMoreIcon, null) },
                    React.createElement("h6", null,
                        React.createElement("strong", null, video.area ? React.createElement("em", null, owner) : owner),
                        " ",
                        video.title,
                        " ",
                        React.createElement("br", null))),
                React.createElement(ExpansionPanelDetails, null,
                    React.createElement("div", { className: "container" },
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col s8" },
                                React.createElement("video", { className: "center video-item", controls: true },
                                    React.createElement("source", { src: ((_d = video.url) === null || _d === void 0 ? void 0 : _d.startsWith("http")) ? video.url : serverUri + video.url }))),
                            React.createElement("div", { className: "col s4" },
                                React.createElement("ul", null,
                                    React.createElement("li", null,
                                        React.createElement("h5", null, "Devices")),
                                    _this.deviceList(video.id)))))),
                React.createElement(Divider, null),
                React.createElement(ExpansionPanelActions, null,
                    React.createElement(Link, { to: "/videos/" + video.id },
                        React.createElement(IconButton, null,
                            React.createElement(Icon, null, "edit"))),
                    React.createElement(IconButton, { className: "right", onClick: _this.onDeactivateClick.bind(_this, video.id) },
                        React.createElement(Icon, null, "delete")))));
        });
        return (React.createElement("div", { className: "content" },
            React.createElement("div", { className: "col s12 m12 l12" },
                React.createElement("h5", null, "Videos"),
                React.createElement("br", null),
                videos)));
    };
    VideoList.prototype.deviceList = function (videoId) {
        var devices = this.props.devices.filter(function (d) { return d.videos && d.videos.includes(videoId); });
        return devices
            .map(function (d) { return d.host; })
            .map(function (item, key) { return (React.createElement("li", { key: key },
            item,
            React.createElement("br", null))); });
    };
    VideoList.prototype.onDeactivateClick = function (id) {
        this.props.send(WebSocketMessage("videos", "delete", { id: id }));
    };
    return VideoList;
}(Component));
export default withRouter(VideoList);



//////////////////
// WEBPACK FOOTER
// ./src/components/videos/VideoList.tsx
// module id = 1245
// module chunks = 0